/** Login-challenge methods that Foroba POST /auth/token/2fa accepts (totp, email_otp). */
export type LoginMfaMethod = 'totp' | 'email_otp'

const ORDER: LoginMfaMethod[] = ['totp', 'email_otp']

export function pickMfaMethods(methods: string[] | undefined): LoginMfaMethod[] {
  const usable = ORDER.filter((m) => methods?.includes(m))
  return usable.length > 0 ? usable : ['totp']
}
